import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SoroBlog from "@/components/SoroBlog";
import StickyCall from "@/components/StickyCall";

export default function Blog() {
  return (
    <main data-testid="blog-page" className="bg-[#050505] text-white">
      <Header />
      <div className="pt-20">
        <SoroBlog />
      </div>
      <Footer />
      <StickyCall />
    </main>
  );
}
